import React from "react";
import { Box, Container, Link, Typography, Stack } from "@mui/material";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
import { config } from "../core/service/config.service";

const ResearchPeriodExtensionSubmitted = (detail) => {
  const {
    date_submission,
    had_asked_extensions_period_end_date,
    had_asked_extensions_period_start_date,
    mention_details,
    receiver_scholarship_end_date,
    receiver_scholarship_start_date,
    what_time_extend_period_end_date,
    what_time_extend_period_start_date,
    manuscript_available
  } = detail;

  return (
    <Container>
      <Box>
        <Stack direction="row" sx={{ paddingTop: 2 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Start receiving fellowship from:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(receiver_scholarship_start_date).format("DD/MM/YY")} -{" "}
            {moment(receiver_scholarship_end_date).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Previous extension for 2 time(s) from:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(had_asked_extensions_period_start_date).format("DD/MM/YY")}{" "}
            - {moment(had_asked_extensions_period_end_date).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Request research period extension for 3 month(s) from:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(what_time_extend_period_start_date).format("DD/MM/YY")} -{" "}
            {moment(what_time_extend_period_end_date).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 2 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Research paper status:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {mention_details || "-"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Date of submission:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(date_submission).format("DD/MM/YY") || "-"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">Manuscript:</Typography>
          <Link
            href={
              manuscript_available
                ? `${config.host_api}download/${manuscript_available}`
                : null
            }
          >
            {manuscript_available?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const ResearchPeriodExtensionUnSubmitted = (detail) => {
  const {
    had_asked_extensions_period_end_date,
    had_asked_extensions_period_start_date,
    mention_details,
    receiver_scholarship_end_date,
    receiver_scholarship_start_date,
    what_time_extend_period_end_date,
    what_time_extend_period_start_date
  } = detail;

  return (
    <Container>
      <Box>
        <Stack direction="row" sx={{ paddingTop: 2 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Start receiving fellowship from:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(receiver_scholarship_start_date).format("DD/MM/YY")} -{" "}
            {moment(receiver_scholarship_end_date).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Previous extension for 2 time(s) from:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(had_asked_extensions_period_start_date).format("DD/MM/YY")}{" "}
            - {moment(had_asked_extensions_period_end_date).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Request research period extension for 3 month(s) from:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {moment(what_time_extend_period_start_date).format("DD/MM/YY")} -{" "}
            {moment(what_time_extend_period_end_date).format("DD/MM/YY")}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 2 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Research paper status:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {mention_details || "-"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Details:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {mention_details || "-"}
          </Typography>
        </Stack>
      </Box>
    </Container>
  );
};

export default function ResearchPeriodExtensionModal({ detail }) {
  return (
    <>
      {detail?.date_submission !== "0000-00-00"
        ? ResearchPeriodExtensionSubmitted(detail)
        : ResearchPeriodExtensionUnSubmitted(detail)}
    </>
  );
}
